<template>   
   <div class="problem-alert" v-if="message">
      <div class="alert alert-danger">{{ message }}</div>

      <div class="problem-alert__btn-bar">

         <button class="btn btn-primary" v-on:click="on_click_ok">
            <i class="fas fa-check"></i>
            OK
         </button>
      </div>
   </div>
</template>

<script>
export default {
   props: [
      'message'
   ],

   methods:{
      on_click_ok (){
         this.clear_show();
         this.$emit( 'ok' );
      }
   }// /methods{}
   
};
</script>

<style scoped>
.problem-alert
{
   box-sizing: border-box;
   padding: 1em;
   border: 1px solid #cccccc;
}

.problem-alert__btn-bar
{
   display: flex;
   justify-content: flex-end;
}
</style>